__turbopack_context__.v({
  "activityLine": "ai-chat-drawer-module__qeh59W__activityLine",
  "chatElement": "ai-chat-drawer-module__qeh59W__chatElement",
  "dockRow": "ai-chat-drawer-module__qeh59W__dockRow",
  "dockedPanel": "ai-chat-drawer-module__qeh59W__dockedPanel",
  "dockedPanelInner": "ai-chat-drawer-module__qeh59W__dockedPanelInner",
  "drawer": "ai-chat-drawer-module__qeh59W__drawer",
  "drawer-border-draw": "ai-chat-drawer-module__qeh59W__drawer-border-draw",
  "drawer-border-undraw": "ai-chat-drawer-module__qeh59W__drawer-border-undraw",
  "drawer-in": "ai-chat-drawer-module__qeh59W__drawer-in",
  "drawer-light-done": "ai-chat-drawer-module__qeh59W__drawer-light-done",
  "drawer-light-scan": "ai-chat-drawer-module__qeh59W__drawer-light-scan",
  "drawer-out": "ai-chat-drawer-module__qeh59W__drawer-out",
  "overlay": "ai-chat-drawer-module__qeh59W__overlay",
  "resizeHandle": "ai-chat-drawer-module__qeh59W__resizeHandle",
  "sidePanel": "ai-chat-drawer-module__qeh59W__sidePanel",
  "sidePanelClip": "ai-chat-drawer-module__qeh59W__sidePanelClip",
});
